import { useRef, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import LeftSubMenu from "../LeftSubMenu";
import { logout } from "../../../../utils/auth";
import "../../../../assets/css/style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  setEventData,
  setEventLoading,
  setEventError
} from "../../../../store/eventSlice";

import { setUserData } from "../../../../store/userSlice";

import { setLoader } from "../../../../store/loaderSlice";
import axiosInstance from "../../../../utils/axiosInstance";

const ClientLayoutWithOutHeader = ({ children, showLoader = true }) => {
  const [displaySidebar, setDisplaySidebar] = useState(false);
  const [displaySubMenu, setDisplaySubMenu] = useState(false);
  const [displayTopRightMenu, setDisplayTopRightMenu] = useState(false);
  const [gameType, setGameType] = useState(0);
  const isloader = false;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  function ShowLeftMenuBySports(displaySubMenu, game_type) {
    setDisplaySubMenu(displaySubMenu);
    setGameType(game_type);
  }

  useEffect(() => {
    const fetchEvents = async () => {
      //console.log("Fetching events...");
      try {
        console.log("Trying to fetch events!");
        await dispatch(setLoader(true));
        const response = await axiosInstance.get("/events");

        if (response.data.result !== "") {
          await dispatch(setEventData(response.data));
        }
        await dispatch(setLoader(false));
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };

    fetchEvents();
  }, []);

  const topRightMenuRef = useRef(null);
  //const navigate = useNavigate();

  // Function to handle clicks outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        topRightMenuRef.current &&
        !topRightMenuRef.current.contains(event.target)
      ) {
        setDisplayTopRightMenu(false); // Or update any value/state you want
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [topRightMenuRef]);

  const loader = useSelector((state) => state.loader);
  const userInfo = useSelector((state) => state.userStore);
  let username = "";
  let balance = 0;
  let expouser = 0;
  if (
    userInfo !== null &&
    userInfo !== undefined &&
    userInfo.data !== null &&
    userInfo.data !== undefined
  ) {
    username = userInfo.data.uname;
    balance = parseInt(userInfo.data.bz_balance);
    expouser = parseInt(userInfo.data.opin_bal - userInfo.data.bz_balance);
  }

  //console.log("userInfo->",userInfo);

  return (
    <div className={displaySidebar ? "body-active" : ""}>
      {loader.loading && showLoader && (
        <div
          style={{
            position: "absolute",
            zIndex: "1000",
            background: "#ddd",
            width: "100%",
            height: "20%",
            opacity: 1
          }}
        >
          <div className="top_loader_css">
            <img src="../assets/images/loadinggif.gif" alt="Loader" />
          </div>
        </div>
      )}

      <div>
        <div
          style={{
            background: "var(--theme-color)",
            padding: "10px 15px 10px 15px"
          }}
          className="header"
        >
          <Link to="/home" style={{ textDecoration: "none" }}>
            <span
              className="logo_name"
              style={{ fontSize: 25, color: "#04b181", fontWeight: "bold" }}
            >
              BPEXCH
            </span>
          </Link>
        </div>
      </div>

      <section className="home-section">
        <div
          className="right-side-wrapper-row"
          style={{ background: "#dde1e5", padding: "0px" }}
        >
          {children}
        </div>
        <section className="footer-section" style={{ marginTop: "10px" }}>
          <div className="container"></div>
        </section>
      </section>
    </div>
  );
};

export default ClientLayoutWithOutHeader;
